const InpatientStatus = {
    1: 'inpatient',
    2: 'outpatient',
    3: 'emergency',
};

export default InpatientStatus;